import { createFileRoute } from '@tanstack/react-router'
import { LoginBannerPage } from '@/features/login-banner'

export const Route = createFileRoute('/_authenticated/login-banner/')({
  component: LoginBannerPage,
})
